import MMS from './MMS';
import HRMS from './HRMS';
import SPM from './SPM';
import CRM from './CRM';
import WMS from './WMS';
import IMS from './IMS';

export { MMS, HRMS, SPM, CRM, WMS, IMS };
export default { MMS, HRMS, SPM, CRM, WMS, IMS };
